import "@plannel/scss/components/CustomTooltip.scss";

const CustomTooltip = (props) => {
  const { value, style = {} } = props;

  return (
    <div className="custom-tooltip" style={style}>
      <p>{value}</p>
    </div>
  );
};

export default CustomTooltip;